import Vue from 'vue';

const REG = {
  email: /^[A-Za-z0-9_-]+@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/, // 邮箱 /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.(com|com.cn|net|msn.cn))+$/
  mobile: /^1\d{10}$/,
  telephone: /^(0\d{2,3}\d{7,8})|(1\d{10})$/, // /^(0\d{2,3}-\d{7,8})|(1\d{10})$/
  passWord: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,32}$/, // 密码由6~20位数字+字母、特殊字符组成，且不能为纯数字、字母、特殊字符
  strongPwd: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,20}$/,
  account: /^[a-zA-Z0-9][a-zA-Z0-9_-]{3,19}$/,
  code: /^[a-zA-Z0-9][a-zA-Z0-9-_.\s]{1,19}$/, // 就是2-20位的范围
  longCode: /^[a-zA-Z0-9][a-zA-Z0-9-_]{1,49}$/,
  name: /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9._-]{1,19}$/,
  communityName: /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9_-]{1,19}$/,
  version: /^[a-zA-Z0-9][a-zA-Z0-9.]{1,19}$/,
  userName: /^[\u4e00-\u9fa5a-zA-Z]{2,10}$/,
  addressName: /^([\u4e00-\u9fa5a-zA-Z0-9_-]*[`!@#$%^&*\(\)_\-\+\=\<\>\?\:\\{}|,./;’\[\]·！@#￥%……&*"\（\）\——\-\+\={}|《》？：“”【】、；‘’，。、~\n\s]*){0,100}$/,
  mac: /^[a-zA-Z0-9][a-zA-Z0-9-_:]{1,19}$/,
  unSpecialChar: /^[\u4e00-\u9fa5\w-]+$/,
  nonnegative: /^[0-9]*\.?[0-9]*$/,
  money: /^[0-9]*\.?[0-9]*$/,
  positiveInt: /^[1-9]\d*$/,
  nonnegativeInteger: /^[0-9]*$/,
  nonEmpty: /^([\s]*[\S]+[\s]*[\S]*)+$/
};

const MESSAGE = {
  mobile: '手机号为11位有效数字',
  email: '邮箱格式不正确',
  telephone: '请输入有效的手机号或座机号',
  passWord: '6-32位，不能为纯数字,字母,特殊字符',
  strongPwd: '6-20位，包含大小写字母和数字的组合，不使用特殊字符',
  account: '4-20位字母,数字,中划线,下划线，第一位不为中或下划线',
  code: '2-20位数字、字母，非特殊字符',
  name: '2-20位汉字,数字,字母，非特殊字符',
  communityName: '小区名为2-20位汉字、字母、数字',
  version: '2-20位数字,字母,点',
  userName: '2-10位汉字',
  addressName: '不能包含特殊字符',
  mac: '2-20位数字,字母,冒号,第一位不为冒号',
  nonnegative: '请输入大于等于0的数',
  unSpecialChar: '请输入汉字、字母、数字',
  money: '请输入正确的金额格式',
  positiveInt: '请输入正整数',
  nonnegativeInteger: '请输入非负整数',
  whitespace: { whitespace: true, message: '不能输入空格' },
  nonEmpty: '不能为空'
};

Vue.prototype.REG = REG;

Vue.prototype.MESSAGE = MESSAGE;

export { REG, MESSAGE };
